import React, {memo} from 'react';
import {Download, File, UserMinus, UserPlus} from 'react-feather';
import {formatBytes} from "../../services/helpers";
import he from "he";
import UserAvatar from "./UserAvatar";
import {getConversationFiles} from "../../services/api/messaging";
import Tooltip from "../Common/Tooltip";
import ForwardIcon from "../../images/svg/message/flip-forward.svg";
import {MESSAGE_USER_ADDED, MESSAGE_USER_FORWARDED, MESSAGE_USER_REMOVED} from "../../services/constants/MessageStatus";
import {moment} from "../../services/moment-extensions";


const MessageItemNotification = ({item, authData}) => {

    const itemType = parseInt(item.type);

    if (itemType === MESSAGE_USER_REMOVED)
        return (
            <div
                className="sl-flex sl-gap-1 sl-flex-row sl-w-fit-content sl-align-self-center sl-break-all sl-font sl-text-sm sl-font-medium sl-text-center sl-bg-gray-100 sl-rounded-2xl sl-pt-1 sl-pb-1 sl-pl-12 sl-pr-12 sl-text-gray-700">

                <UserMinus size={16} className="sl-text-gray-700"/>

                <span>{
                    item.account.id === authData.id ? (
                        <span className={"sl-font-semibold"}>You </span>
                    ) : (
                        <span
                            className={"sl-font-semibold"}>{item.account.first_name} {item.account.last_name} </span>
                    )
                }
                    removed <span className={"sl-font-semibold"}>{he.decode(item.content)}</span> from the conversation</span>
            </div>
        )


    if (itemType === MESSAGE_USER_ADDED)
        return (
            <div
                className="sl-flex sl-gap-1 sl-flex-row sl-w-fit-content sl-align-self-center sl-break-all sl-font sl-text-sm sl-font-medium sl-text-center sl-bg-gray-100 sl-rounded-2xl sl-pt-1 sl-pb-1 sl-pl-12 sl-pr-12 sl-text-gray-700">

                <UserPlus size={16} className="sl-text-gray-700"/>

                <span>{
                    item.account.id === authData.id ? (
                        <span className={"sl-font-semibold"}>You </span>
                    ) : (
                        <span
                            className={"sl-font-semibold"}>{item.account.first_name} {item.account.last_name} </span>
                    )
                }
                    added <span
                        className={"sl-font-semibold"}>{he.decode(item.content)}</span> to this conversation</span>
            </div>
        )

    if (itemType === MESSAGE_USER_FORWARDED)
        return (
            <div
                className="sl-flex sl-gap-1 sl-flex-row sl-w-fit-content sl-align-self-center sl-break-all sl-font sl-text-sm sl-font-medium sl-text-center sl-bg-gray-100 sl-rounded-2xl sl-pt-1 sl-pb-1 sl-pl-12 sl-pr-12 sl-text-gray-700">
                <img width={16} height={16} className="sl-text-gray-700" alt={"Forward"} src={ForwardIcon}/>
                <span>{
                    item.account.id === authData.id ? (
                        <span className={"sl-font-semibold"}>You </span>
                    ) : (
                        <span
                            className={"sl-font-semibold"}>{item.account.first_name} {item.account.last_name} </span>
                    )
                }
                    forwarded the conversation to <span
                        className={"sl-font-semibold"}>{he.decode(item.content)}</span> and left conversation</span>
            </div>
        )
}

const MessageItem = memo(({item, activeConversation, authData, showDate}) => {
    const handleDownloadFile = (file) => {
        getConversationFiles(activeConversation.id, file.location).then(response => {
            const downloadLink = document.createElement("a");
            downloadLink.href = response.url;
            downloadLink.download = file.name;
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        });
    };

    return (
        <div className="sl-flex sl-flex-col sl-p-0 sl-m-0 sl-gap-6">
            {showDate && <div
                className="sl-content-divider sl-w-full sl-grow-1 sl-font-normal sl-text-sm sl-text-gray-600">
                {moment(item.created_at * 1000).toDateLongWithToday()}
            </div>}

            {[MESSAGE_USER_ADDED, MESSAGE_USER_REMOVED, MESSAGE_USER_FORWARDED].includes(parseInt(item.type)) ?
                <MessageItemNotification item={item} authData={authData}/> : (
                    <div className="sl-grow-1 sl-text-gray-900 sl-flex sl-gap-3">
                        <div className="sl-flex sl-flex-col">
                            <UserAvatar userData={item.account}
                                        avatarClass="sl-flex sl-h-12 sl-w-12"/>
                        </div>
                        <div className="sl-grow-1 sl-flex sl-flex-col sl-justify-flex-start">
                            <div className="sl-flex sl-align-center sl-justify-flex-start sl-gap-2">
                                <div
                                    className="sl-flex sl-align-center sl-font sl-font-semibold sl-text-lg sl-text-gray-900">
                                    <div>
                                        {item.account.first_name} {item.account.last_name}
                                    </div>
                                </div>
                                <div className='sl-text-gray-500 sl-text-sm sl-font-normal sl-font'>
                                    {moment(item.created_at * 1000).toShortTimeWithNow()}
                                </div>
                            </div>
                            <div
                                className="sl-flex sl-align-center sl-gap-1 sl-justify-flex-start">
                                <div
                                    dangerouslySetInnerHTML={{__html: item.content}}
                                    className="sl-font sl-text-md sl-text-left sl-font-normal sl-text-gray-900 sl-white-space-pre-line sl-break-words-anywhere">

                                </div>
                            </div>
                        </div>
                    </div>
                )}

            {item.files &&
                <div
                    className="sl-w-full sl-flex sl-flex-col sl-gap-2 sl-align-center sl-justify-center">
                    {item.files.map((file, index) => (
                        <div
                            key={index}
                            rel={file.id}
                            className=' sl-border  sl-border-solid sl-border-gray-200  sl-flex sl-bg-white sl-rounded-lg sl-shadow-xs sl-pb-2-last-0 sl-px-1 sl-py-2 sl-rounded-lg sl-w-fill-available sl-justify-space-between sl-align-center'>
                            <div
                                className="sl-flex sl-w-full sl-justify-start sl-align-center sl-gap-3 sl-mb-2">
                                <div>
                                    <div
                                        className="sl-p-2 sl-m-auto sl-w-8 sl-h-8 sl-rounded-full sl-bg-primary-50 sl-text-primary-600">
                                        <File size={16} className="sl-text-primary-600"/>
                                    </div>
                                </div>

                                <div
                                    className="sl-grow-1 sl-w-full sl-flex sl-flex-col sl-justify-items-start sl-align-flex-start">
                                    <div
                                        className="sl-font sl-text-sm sl-font-medium sl-text-gray-900 sl-mr-1">
                                        {file.name}
                                    </div>
                                    {file.size &&
                                        <div
                                            className="sl-font-normal sl-text-xs sl-text-gray-base">
                                            {formatBytes(file.size)}
                                        </div>}
                                </div>

                                <Tooltip content="Download" disabled={false}>
                                    <button
                                        className="sl-btn sl-btn-md sl-btn-clear sl-p-2-point-5 sl-max-h-10 sl-max-w-10 sl-self-end"
                                        onClick={() => handleDownloadFile(file)}>
                                        <Download size={20}
                                                  className="sl-cursor-pointer sl-text-gray-base"/>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>))}
                </div>}
        </div>
    );
});

export default MessageItem;
